// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__39BFD","header":"MessagesList_header__2XV1t","chat":"MessagesList_chat__6KHnp"};